"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  planDetails: {},
  inclusions: [],
  numberOfAddons: 0,
  planDates: {},
  rates: [],
  isFetching: true
};
exports.default = _default;